import i18n from '@/i18n'

// Generic boilerplate text some backend error handlers return for unhandled
// exceptions (e.g. a framework's default 500 body) - never actionable for the
// user, so it's treated the same as having no message at all.
const GENERIC_BACKEND_MESSAGES = ['server error', 'internal server error']

// Accepts `unknown` (not just `NullableType<Error>`) so callers can pass the
// `catch (error)` variable directly - under strict mode TS types that as
// `unknown`, not `Error`.
const hasMessage = (error: unknown): error is { message: string } =>
  typeof error === 'object' &&
  error !== null &&
  'message' in error &&
  typeof (error as { message?: unknown }).message === 'string' &&
  !!(error as { message: string }).message &&
  !GENERIC_BACKEND_MESSAGES.includes((error as { message: string }).message.trim().toLowerCase())

export const getApiErrorMessage = <T extends unknown[]>(
  // NOTE: special guard check to ensure at least one argument is passed in the end
  ...errors: T extends [] ? never : T
): string => {
  const foundError = errors.find(hasMessage)
  return foundError?.message || i18n.t('common:errors.generic')
}
